var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('SecondaryButton',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.openDialog.apply(null, arguments)}}},[_vm._v(" Bulk Timesheets ")]),_c('BulkTimesheetsDialog',{attrs:{"isOpen":_vm.isDialogOpen},on:{"close":_vm.closeDialog,"save":function($event){return _vm.$emit('save')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }